export enum ClerkMetadataKey {
  INBOX_TABS_CONFIG = 'ht_inbox_tabs_config',
  SHOW_LABEL_BADGE_TITLES = 'ht_show_label_badge_titles',
  INBOX_ACCOUNT_FILTER = 'ht_inbox_account_filter',
  DOBOX_SORT_CONFIG = 'ht_dobox_sort_config',
  DOBOX_RECENT_MEMBERS = 'ht_dobox_recent_members',
  ACTIVE_TEAM_ID = 'ht_active_team_id',
  DOBOX_VIEW_MODE_BY_TASK_GROUP = 'ht_dobox_view_mode_by_task_group',
  DISMISSED_HANDOFF_CARD_TEAM_IDS = 'ht_dismissed_handoff_card_team_ids',
  SUGGESTION_SOUND_ENABLED = 'ht_suggestionSoundEnabled',
  ARCHIVE_EMAIL_ON_TASK_RESOLVE = 'ht_archiveEmailOnTaskResolve',
  EMAIL_SIGNATURE = 'ht_email_signature',
  USER_TITLE = 'ht_title',
}
